import React from 'react'

import { Button, CircularProgress , Box, TextField } from '@material-ui/core'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import NewQuestionEditor from './component/NewQuestionEditor'

import { 
	DataGrid, 
	GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
	GridActionsCellItem
} from '@mui/x-data-grid'

import config from '../config'
import Snack from '../Snack'
import Edit from '@mui/icons-material/Edit'

const api = require('../api/api')

function customToolbar() {
	return (
		<GridToolbarContainer>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarExport />
		</GridToolbarContainer>
	)
}

export default class QuestionEditorTab extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			data: [],
			error: '',
			loading: true,
			selectedRows: [],
			topics: [],
			searchValue: ''
		}

		this.columns = []
		this.questionEditor = React.createRef()
	}

	setupGrid(topics) {
		this.columns = [
			{ field: 'id', headerName: 'ID', width: 70, type: 'number' },
		
			{ 
				field: 'type', 
				headerName: 'Type', 
				width: 130, 
				// editable: true,
				type: 'singleSelect',

				valueOptions: config.server.question.types,
				valueParser: (params) => config.server.question.types.indexOf(params),
				valueFormatter: (params) => config.server.question.types[params.value]
			},
		
			{ field: 'text', headerName: 'Question', width: 420, /* editable: true */ },
			
			{
				field: 'topic', 
				headerName: 'Topic', 
				width: 130, 
				// editable: true,
				type: 'singleSelect',

				valueOptions: topics,
				valueParser: (params) => topics.indexOf(params),
				valueFormatter: (params) => topics[params.value]
			},
			
			{ 
				field: 'tags', 
				headerName: 'Tags', 
				width: 140,
				
				valueFormatter: (params) => params.value.join(' ')
			},

			{
				field: 'actions',
				type: 'actions',
				headerName: 'Edit',
				getActions: (params) => [ <GridActionsCellItem icon={<Edit />} onClick={
					this.edit.bind(this, params)
				} label="Edit" /> ]
			}
		]
	}

	edit(params) {
		const requestedId = params.row.id
		let id = -1

		for (let i in this.state.data) {
			let row = this.state.data[i]

			if (row.id == requestedId) {
				id = parseInt(i)
				break
			}
		}

		this.questionEditor.current.open(id, this.state.data[id])
	}

	fetch() {
		this.setState({
			loading: true
		})

		api.questions.list().then(res => {
			this.setState({
				loading: false,
				data: res.questions
			})
		}).catch(err => {
			this.setState({
				error: err,
				loading: false
			})

			console.error(err)
		})
	}

	componentDidMount() {
		this.fetch()

		api.topics.list().then(res => {
			let topics = []

			for (let topic of res.topics) {
				topics.push(topic.name)
			}

			this.setupGrid(topics)

			this.setState({
				loading: false,
				topics: topics
			})
		}).catch(err => {
			this.setState({
				error: err,
				loading: false
			})

			console.error(err)
		})
  }

	onClose(added) {
		if (added) {
			const data = this.questionEditor.current.getData()
			const isNew = data.isNew
			const cc = (isNew ? api.questions.insert : api.questions.update)

			cc(data).then((result) => {
				// Sadly, this code is bugged, so going with a lazy fetch of all data
				/*let d = JSON.parse(JSON.stringify(this.state.data))

				if (isNew) {
					d = d.slice(0)
					data.id = result.question.id

					d.push(data)
				} else {
					for (let i = 0; i < d.length; i++) {
						if (d[i].id == data.id) {
							d[data.id] = data

							break
						}
					}
				}

				this.setState({ 
					loading: false, 
					data: d
				})*/

				this.fetch()
			}).catch(err => {
				Snack.instance.show(err)
				console.error(err)

				this.setState({
					error: err,
					loading: false
				})
			})
		} else {
			this.setState({
				loading: false
			})
		}
	}

	handleGridChange(data) {
		let request = { id: data.id }
		request[data.field] = data.value

		api.questions.update(request).catch(error => console.error(error))
	}
	
	handleCheckboxChange(rows) {
		this.setState({
			selectedRows: rows
		})
	}
	
	handleDelete() {
		const rows = this.state.selectedRows

		if (rows.length == 0) {
			return
		}

		this.setState({ loading: true })

		api.questions.remove({
			id: rows
		}).then(() => {
			let data = this.state.data.slice(0) // Make a copy of a readonly array

			for (let i = data.length - 1; i >= 0; i--) {
				if (rows.indexOf(data[i].id) != -1) {
					data.splice(i, 1)
				}
			}
	
			this.setState({
				data: data,
				loading: false
			})
		}).catch(error => {
			Snack.instance.show(error)
			console.error(error)

			this.setState({ loading: false })
		})
	}

	handleAdd() {
		this.setState({ loading: true })
		this.questionEditor.current.open()
	}

	updateSearchValue(e) {
		this.setState({
			searchValue: e.target.value
		})
	}

	render() {
		let search = this.state.searchValue.length > 0
		let data = search ? [] : this.state.data

		if (search) {
			let searchValue = this.state.searchValue.toLowerCase()

			for (let row of this.state.data) {
				if (row.text.toLowerCase().indexOf(searchValue) != -1 || row.id.toString().indexOf(searchValue) != -1) {
					data.push(row)
				}
			}
		}
			
		return <Box sx={{ position: 'relative' }}>
			<div style={{ height: 720, width: '100%' }}>
				<Button disabled={this.state.loading} variant="contained" color="primary" aria-label="add" onClick={this.handleAdd.bind(this)} style={{ marginRight: '15px', marginBottom: '15px' }}>
					<AddIcon />
				</Button>

				<Button disabled={this.state.loading || this.state.selectedRows.length == 0} variant="contained" size="medium" color="secondary" aria-label="delete" style={{ marginRight: '15px', marginBottom: '15px' }} onClick={this.handleDelete.bind(this)}>
					<DeleteIcon />
				</Button>


				<TextField value={this.state.searchValue} onChange={this.updateSearchValue.bind(this)} label="Search" style={{ marginTop: '-15px', marginBottom: '15px' }} />

				<DataGrid
					className={this.state.loading ? 'disabledGrid' : 'regularGrid'}
					rows={data}
					columns={this.columns}
					pageSize={10}
					rowsPerPageOptions={[10]}
					checkboxSelection
					onCellEditCommit={this.handleGridChange.bind(this)}
					onSelectionModelChange={this.handleCheckboxChange.bind(this)}
					components={{
						Toolbar: customToolbar
					}}
				/>
			</div>

			<NewQuestionEditor ref={this.questionEditor} onClose={this.onClose.bind(this)} topics={this.state.topics} />
			{ this.state.loading && this.renderProgressBar() }
		</Box>
	}

	renderProgressBar() {
		return <CircularProgress size={48} className='loadingBar' />
	}
}
